import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getPlayer = (data: PropertyType): Promise<PropertyType> => {
	return api.post(`players`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
};
